import { memo, RefObject, useCallback, useMemo } from 'react';
import cn from 'classnames';

import styles from './SelectOrganisationsItem.module.scss';

interface ISelectOrganisationsItemProps {
  name?: string;
  expanding?: boolean;
  active: boolean;
  selectable?: boolean;
  disabled?: boolean;
  highlighted?: boolean;
  onToggle: () => void;
  onExpand?: () => void;
  refToScroll?: RefObject<HTMLDivElement>;
}

export const SelectOrganisationsItem = memo(
  ({
    name,
    expanding,
    active,
    selectable = true,
    disabled,
    highlighted,
    onToggle,
    onExpand,
    refToScroll,
  }: ISelectOrganisationsItemProps) => {
    const onClick = useCallback(() => {
      if (selectable && !disabled) {
        onToggle();
      }
    }, [disabled, selectable, onToggle]);

    const elementClassNames = useMemo(
      () =>
        cn(styles.Element, {
          [styles.ElementExpanding]: expanding,
          [styles.ElementActive]: active,
          [styles.ElementNotSelectable]: !selectable,
          [styles.ElementDisabled]: disabled,
          [styles.ElementHighlighted]: highlighted,
        }),
      [expanding, active, selectable, disabled, highlighted],
    );

    return (
      <div className={elementClassNames} ref={refToScroll}>
        <button className={styles.Button} onClick={onClick}>
          {name}
        </button>
        {expanding && (
          <button className={styles.ExpandButton} onClick={onExpand}>
            …
          </button>
        )}
      </div>
    );
  },
);
